<template>
  <div class="vadDashTimeline is-relative">
    <div class="has-background-white is-border is-padding-left row-width-actions-bar">
      <div
        class="columns is-gapless is-vcentered"
        style="min-height:5.656rem">
        <!-- minHeight en dur pour correspondre à la hauteur des onglets de la colonne de droite-->
        <div class="column ">
          <strong class="is-size-3">Mes tâches</strong>
        </div>
        <div class="column is-narrow is-padding-right-xsmall">
          <span class="tag is-primary is-margin-left-xsmall is-rounded">{{ totalEvents }}</span>
        </div>
        <div class="column is-narrow is-self-stretched">
          <div class="dropdown is-hoverable is-right is-minH100">
            <div class="dropdown-trigger is-minH100">
              <a class="page-header-btn is-square is-minH100">
                <span
                  class=""
                  aria-haspopup="true"
                  aria-controls="dropdown-menu">
                  <i class="fal fa-filter"></i>
                </span>
              </a>
            </div>
            <div
              class="dropdown-menu"
              id="dropdown-menu"
              role="menu">
              <div class="dropdown-content has-text-left">
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="options"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle is-primary"
                    v-model="displayedEvents"
                    :value="EVENT_TYPES.OPTION">
                  <label for="options">Options</label>
                </div>
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="denunciations"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle"
                    v-model="displayedEvents"
                    :value="EVENT_TYPES.CLAIM">
                  <label for="denunciations">Dénonciations</label>
                </div>
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="reservation"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle"
                    v-model="displayedEvents"
                    :value="EVENT_TYPES.PENDING_RESERVATIONS">
                  <label for="reservation">Dossier à valider</label>
                </div>
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="tickets"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle"
                    v-model="displayedEvents"
                    :value="EVENT_TYPES.TICKET">
                  <label for="tickets">Tickets</label>
                </div>
                <div class="control dropdown-item is-nowrap">
                  <input
                    id="reminders"
                    type="checkbox"
                    name="column"
                    class="is-checkradio is-circle"
                    v-model="displayedEvents"
                    :value="EVENT_TYPES.REMINDER">
                  <label for="reminders">Rappels</label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <template v-for="wrapper in timeline">
      <div
        :key="'header-'+wrapper.key"
        class="vadDashTimeline-date is-margin-top">
        <div class="has-background-light is-minH50p is-flex is-padding-top-xxsmall is-padding-bottom-xxsmall is-padding-left">
          <strong class="is-size-6 is-block is-uppercase is-self-centered">
            {{ wrapper.date | dtFormat('dddd') }} {{ wrapper.date | dtFormat('DD MMMM') }}
          </strong>
        </div>
      </div>
      <div
        :key="'events-'+wrapper.key"
        class="vadDashTimeline-events is-margin-top">
        <component
          v-for="event in wrapper.events"
          :key="event.pk"
          :ticket="event"
          :reservation="event"
          :option="event"
          :claim="event"
          :reminder="event"
          :is="EVENT_COMPONENTS[event.type]"
          @updateTicket="updateTicket"
          @updateClaim="updateClaim">
        </component>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import moment from 'moment'
import { orderBy } from 'lodash/collection'
import { bus, EVENTS } from '@/bus'

const EVENT_TYPES = Object.freeze({
  OPTION: 'OPTION',
  CLAIM: 'CLAIM',
  PENDING_RESERVATIONS: 'PENDING_RESERVATIONS',
  TICKET: 'TICKET',
  REMINDER: 'REMINDER'
})

const EVENT_COMPONENTS = Object.freeze({
  OPTION: 'OptionCard',
  CLAIM: 'ClaimCard',
  PENDING_RESERVATIONS: 'ReservationCard',
  TICKET: 'TicketCard',
  REMINDER: 'ReminderCard'
})

export default {
  name: 'TodoList',
  // eslint-disable-next-line vue/no-unused-components
  components: {
    ReservationCard: () => import('./ReservationCard'),
    ClaimCard: () => import('./ClaimCard'),
    OptionCard: () => import('./OptionCard'),
    TicketCard: () => import('./TicketCard'),
    ReminderCard: () => import('./ReminderCard')
  },
  props: {
    pendingClaims: {
      type: Array,
      required: false,
      default: () => []
    },
    pendingReservations: {
      type: Array,
      required: false,
      default: () => []
    },
    newTickets: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  data () {
    return {
      EVENT_TYPES: EVENT_TYPES,
      EVENT_COMPONENTS: EVENT_COMPONENTS,
      displayedEvents: [],
      initialDisplayedEvents: [EVENT_TYPES.OPTION, EVENT_TYPES.CLAIM, EVENT_TYPES.PENDING_RESERVATIONS, EVENT_TYPES.TICKET, EVENT_TYPES.REMINDER],
      alertDisableForUser: false
    }
  },
  computed: {
    ...mapGetters(['isAdmin', 'isManager', 'isPromoteur', 'runningOptions', 'calendarReminder']),
    ...mapState(['currentUser']),
    /**
      * timeline
      * return each event if type is in displayEvents
      * @return {array}
      */
    timeline () {
      let events = []
      if (this.displayedEvents.includes(EVENT_TYPES.PENDING_RESERVATIONS)) {
        for (let reservation of this.pendingReservations) {
          if (this.isDisableAlert(reservation) === false) {
            let date = moment(reservation.updated_on)
            let wrapper = {
              event: reservation,
              type: EVENT_TYPES.PENDING_RESERVATIONS,
              date
            }
            wrapper.event.type = EVENT_TYPES.PENDING_RESERVATIONS
            events.push(wrapper)
          }
        }
      }
      if (this.displayedEvents.includes(EVENT_TYPES.TICKET)) {
        for (let ticket of this.newTickets) {
          let date = moment(ticket.created_on)
          let wrapper = {
            event: ticket,
            type: EVENT_TYPES.TICKET,
            date
          }
          wrapper.event.type = EVENT_TYPES.TICKET
          events.push(wrapper)
        }
      }
      if (this.displayedEvents.includes(EVENT_TYPES.CLAIM)) {
        for (let claim of this.pendingClaims) {
          if (this.isDisableAlert(claim) === false) {
            let date = moment(claim.created_on)
            let wrapper = {
              event: claim,
              type: EVENT_TYPES.CLAIM,
              date
            }
            wrapper.event.type = EVENT_TYPES.CLAIM
            events.push(wrapper)
          }
        }
      }

      if (this.displayedEvents.includes(EVENT_TYPES.OPTION)) {
        for (let option of this.runningOptions) {
          if (this.isDisableAlert(option) === false) {
            let date = moment(option.created_on)
            let wrapper = {
              event: option,
              type: EVENT_TYPES.OPTION,
              date
            }
            wrapper.event.type = EVENT_TYPES.OPTION
            events.push(wrapper)
          }
        }
      }
      if (this.displayedEvents.includes(EVENT_TYPES.REMINDER)) {
        let reminders = this.calendarReminder.filter(x => {
          const today = moment().startOf('day')
          const isReminderForMe = x.user.pk === this.currentUser.pk
          return moment(x.date).isSame(today, 'd') && isReminderForMe
        })
        for (let reminder of reminders) {
          let date = moment(reminder.date)
          let wrapper = {
            event: reminder,
            type: EVENT_TYPES.REMINDER,
            date
          }
          wrapper.event.type = EVENT_TYPES.REMINDER
          events.push(wrapper)
        }
      }

      events = orderBy(events, 'date', 'desc')

      function appendDateWrapper (date) {
        const key = date.format('DD/MM/YYYY')
        if (!(key in timeline)) {
          timeline[key] = {
            date,
            key: date.unix(),
            [EVENT_TYPES.OPTION]: [],
            [EVENT_TYPES.TICKET]: [],
            [EVENT_TYPES.CLAIM]: [],
            [EVENT_TYPES.REMINDER]: [],
            [EVENT_TYPES.PENDING_RESERVATIONS]: [],
            events: []
          }
        }
        return key
      }

      let timeline = {}
      for (let event of events) {
        const key = appendDateWrapper(event.date)
        timeline[key][event.type].push(event.event)
        timeline[key]['events'].push(event.event)
      }
      return Object.values(timeline)
    },
    /**
      * total events
      * @return {number}
      */
    totalEvents () {
      return this.timeline.reduce((accum, entry) => {
        return accum + entry.events.length
      }, 0)
    }
  },
  watch: {
    'displayedEvents' (v) {
      this.saveConf()
    }
  },
  created () {
    const conf = this.getConf()
    if (conf) {
      this.displayedEvents = []
      for (let c of conf) {
        this.displayedEvents.push(c)
      }
    } else {
      for (const event of this.initialDisplayedEvents) {
        this.displayedEvents.push(event)
      }
      this.saveConf()
    }
    bus.$on(EVENTS.OPTION_CANCELED, this.loadOptions)
  },
  destroyed () {
    bus.$off(EVENTS.OPTION_CANCELED)
  },
  methods: {
    /**
      * load options
      * status waiting_list and approved
      * set in store option list
      */
    async loadOptions () {
      let query = {
        per_page: 100,
        status: ['waiting_list', 'approved']
      }
      try {
        let request = await this.$api.get(this.$resources.OPTION, query)
        this.$store.commit('setOptions', {
          options: request.data.items
        })
      } catch (err) {
        console.log(err)
      }
    },
    /**
      * return todo_list_columnsConf local storage or null
      * @return {object}
      */
    getConf () {
      const localConf = localStorage.getItem('todo_list_columnsConf')
      if (localConf) {
        return JSON.parse(localConf)
      }
      return null
    },
    /**
      * set todo_list_columnsConf in local Storage
      */
    saveConf () {
      localStorage.setItem('todo_list_columnsConf', JSON.stringify(this.displayedEvents))
    },
    /**
      * emit update claim
      * @param {string} - claimPk
      * @param {string} - claim status
      */
    updateClaim (claimPk, status) {
      this.$emit('updateClaim', { claimPk, status })
    },
    /**
      * emit update ticket
      * @param {string} - ticket pk
      * @param {string} - ticket status
      */
    updateTicket (ticketPk, status) {
      this.$emit('updateTicket', { ticketPk, status })
    },
    isDisableAlert (data) {
      if (this.currentUser.disable_program_alert && this.currentUser.disable_program_alert.length !== 0) {
        if (this.currentUser.disable_program_alert.includes(data.program.pk)) {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    }
  }
}
</script>
